import dictionary from './dictionary.json';
const config = {
    resource: 'next-propositions',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map